import { useMemo } from 'react';
import { guid } from '@okee-uikit/react-utils';
export function useGuid() {
  return useMemo(function () {
    return guid();
  }, []);
}